// App.js
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import NavigationBar from './components/NavigationBar/NavigationBar';
import PrivateRoute from './contexts/PrivateRoute';
import AdminRoute from './contexts/AdminRoute';

// Import components
import Login from './components/Auth/Login';
import Signup from './components/Auth/Signup';
import HelpSupport from './components/Support/HelpSupport';
import TipsResources from './components/Support/TipsResources';
import ReferFriend from './components/Referral/ReferFriend';
import HomePage from './components/HomePage';
import Profile from './components/Profile/Profile';
import EditTemplate from './components/Dashboard/EditTemplate';
import UserResumePage from './components/Dashboard/UserResumePage';
import PaymentCancel from './components/Payment/PaypalPaymentCancel';
import PaymentSuccess from './components/Payment/PaypalPaymentSuccess';
import AdminTicketManagement from './components/Support/AdminTicketManagement';
import ChapaPaymentSuccess from './components/Payment/ChapaPaymentSuccess';
import YenePayPaymentSuccess from './components/Payment/YenePayPaymentSuccess';
import Footer from './components/Footer/Footer';
import ScrollToTop from './components/ScrollToTop';

// Import password reset components
import PasswordResetRequest from './components/Auth/RequestPasswordReset';
import ResetPassword from './components/Auth/ResetPassword';
import ReferralUsers from './components/Dashboard/ReferralUsers';



const App = () => {
    return (
        <AuthProvider>
            <NavigationBar />
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route path="/request-password-reset" element={<PasswordResetRequest />} />
                <Route path="/reset-password/:token" element={<ResetPassword />} />

                <Route path="/help-support" element={<PrivateRoute element={<HelpSupport />} />} />
                <Route path="/resources" element={<PrivateRoute element={<TipsResources />} />} />
                <Route path="/referral" element={<PrivateRoute element={<ReferFriend />} />} />
                <Route path="/profile" element={<PrivateRoute element={<Profile />} />} />
                <Route path="/edit-template" element={<PrivateRoute element={<EditTemplate />} />} />
                <Route path="/user-resume" element={<PrivateRoute element={<UserResumePage />} />} />

                <Route path="/paypal/success" element={<PrivateRoute element={<PaymentSuccess />} />} />
                <Route path="/chapa/chapasuccess" element={<PrivateRoute element={<ChapaPaymentSuccess />} />} />
                <Route path="/yenepay/yenepaysuccess" element={<PrivateRoute element={<YenePayPaymentSuccess />} />} />
                <Route path="/paypal/cancel" element={<PrivateRoute element={<PaymentCancel />} />} />

                <Route path="/admin/tickets" element={<AdminRoute element={<AdminTicketManagement />} />} />
                <Route path="/admin/totalusers" element={<AdminRoute element={<ReferralUsers />} />} />

                <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Footer />
        </AuthProvider>
    );
};

export default App;
